import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import Tooltip from "react-tooltip";

const geoUrl = "https://app.mylongbow.com/world-countries.json";
//dataTip variables store the texts that is shown when you hover over the different timeframe buttons
let dataTip1D = "";
let dataTip5D = "";
let dataTip1M = "";
let dataTip3M = "";
let dataTipYTD = "";
export default function EtfFundsFlowsMap({
  data,
  ticker2coordinates,
  latestDate,
}) {
  const [tabValue, setTabValue] = React.useState(0);
  const [handler, setHandler] = React.useState("");

  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  const dataTipDate = (date, subtractDays) => {
    let newDate = "";
    if (subtractDays === "YTD")
      newDate = new Date(new Date().getFullYear(), 0, 1).toLocaleDateString(
        "fr-CA",
      );
    else
      newDate = new Date(
        date.setDate(date.getDate() - subtractDays),
      ).toLocaleDateString("fr-CA");

    return newDate.charAt(5) === "0"
      ? "4:30PM " + newDate.substring(6) + "-" + newDate.substring(0, 4)
      : "4:30PM " + newDate.substring(5) + "-" + newDate.substring(0, 4);
  };

  const formatDate = (date) => {
    let temp = new Date(date);
    if (date) {
      const subtractDay =
        tabValue === 0
          ? 0
          : tabValue === 1
          ? 7
          : tabValue === 3
          ? 30
          : tabValue === 4
          ? 90
          : 120;
      date = temp.setDate(temp.getDate() - subtractDay);
      date = new Date(date).toISOString();
      let newDate =
        date.charAt(5) === "0"
          ? date.substring(6) + "-" + date.substring(0, 4)
          : date.substring(5) + "-" + date.substring(0, 4);
      if (tabValue === 0) {
        temp = new Date(date);
        dataTip1D = dataTipDate(temp, -1);
        temp = new Date(date);
        dataTip5D = dataTipDate(temp, 5);
        temp = new Date(date);
        dataTip1M = dataTipDate(temp, 30);
        temp = new Date(date);
        dataTip3M = dataTipDate(temp, 87);
        temp = new Date(date);
        dataTipYTD = dataTipDate(temp, "YTD");
        date = data[0]?.data?.timestamp;
        let formatTime =
          parseInt(
            date?.substring(date.indexOf("T") + 1, date.indexOf("T") + 6),
          ) - 5;
        if (formatTime < 12) formatTime += ":30AM";
        else if (formatTime === 12) formatTime += ":30PM";
        else formatTime = (formatTime % 12) + ":30PM";
        newDate = formatTime + " " + newDate;
      } else newDate = "4:30PM " + newDate;

      return newDate;
    }
  };

  formatDate(latestDate);

  return (
    <div style={{ padding: "20px 30px" }}>
      <div
        style={{
          color: "white",
          fontSize: 18,
          textAlign: "center",
        }}
      >
        Global ETF Heat Map
      </div>
      <div
        style={{
          paddingTop: 3,
          color: "white",
          fontSize: 12,
          textAlign: "center",
          fontStyle: "italic",
        }}
      >
        Data updates after market close
      </div>
      <div
        className="cross-asset-class-volatility"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div
          className="buttons"
          style={
            window.matchMedia("(max-width: 480px)").matches
              ? { width: "310px" }
              : null
          }
        >
          <div
            data-tip={dataTip1D}
            className={`button ${tabValue === 0 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(0);
            }}
          >
            1D
          </div>
          <div
            data-tip={dataTip5D}
            className={`button ${tabValue === 1 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(1);
            }}
          >
            1W
          </div>
          <div
            data-tip={dataTip1M}
            className={`button ${tabValue === 2 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(2);
            }}
          >
            1M
          </div>
          <div
            data-tip={dataTip3M}
            className={`button ${tabValue === 3 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(3);
            }}
          >
            3M
          </div>
          <div
            data-tip={dataTipYTD}
            className={`button ${tabValue === 4 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(4);
            }}
          >
            YTD
          </div>
        </div>
      </div>
      <ComposableMap
        height={450}
        data-tip=""
        projectionConfig={{ scale: 180, rotate: [-10, 0, 0], center: [8, 6] }}
      >
        <Geographies geography={geoUrl}>
          {({ geographies, projection }) =>
            geographies.map((geo) => (
              <Geography
                style={{
                  default: { fill: "#D6D6DA", outline: "none" },
                  hover: { fill: "#D6D6DA", outline: "none" },
                  pressed: { fill: "#D6D6DA", outline: "none" },
                }}
                key={geo.rsmKey}
                geography={geo}
                fill="#EAEAEC"
                stroke="#D6D6DA"
              />
            ))
          }
        </Geographies>
        {[
          "EWC US Equity",
          "SPY US Equity",
          "EWW US Equity",
          "EPU US Equity",
          "ARGT US Equity",
          "EWZ US Equity",
          "EWU US Equity",
          "EWP US Equity",
          "EWQ US Equity",
          "EWG US Equity",
          "EWI US Equity",
          // "ERUS US Equity",
          "EGPT US Equity",
          "KSA US Equity",
          "INDA US Equity",
          "AFK US Equity",
          "EZA US Equity",
          "EWA US Equity",
          "EWS US Equity",
          "FXI US Equity",
          "EWY US Equity",
          "EWJ US Equity",
          "ECH US Equity",
          "EWL US Equity",
          "ENZL US Equity",
          "EWD US Equity",
          "EWN US Equity",
          "NORW US Equity",
        ].map((ticker, i) => {
          return data[ticker] ? (
            <Marker
              key={ticker}
              coordinates={ticker2coordinates[ticker].coordinates}
            >
              <circle
                r={3}
                fill={getColor(
                  data[ticker]?.[
                    tabValue === 0
                      ? "current_trr_1d"
                      : tabValue === 1
                      ? "current_trr_5d"
                      : tabValue === 2
                      ? "current_trr_1mo"
                      : tabValue === 3
                      ? "current_trr_3mo"
                      : tabValue === 4
                      ? "current_trr_ytd"
                      : ""
                  ],
                )}
                strokeWidth={2}
              />
              <g>
                <rect
                  x={ticker2coordinates[ticker].markerX}
                  y={ticker2coordinates[ticker].markerY}
                  width="80"
                  height="12"
                  fill="#707070"
                ></rect>
                <text
                  textAnchor="middle"
                  alignmentBaseline="central"
                  x={ticker2coordinates[ticker].markerX + 40}
                  y={ticker2coordinates[ticker].markerY + 6}
                  fontFamily="Verdana"
                  fontSize={8}
                  fill="white"
                >
                  {`${ticker2coordinates[ticker].country.toUpperCase()} (${
                    ticker.split(" ")[0]
                  })`}
                </text>
              </g>
              <g>
                <rect
                  x={ticker2coordinates[ticker].markerX}
                  y={ticker2coordinates[ticker].markerY + 11}
                  width="80"
                  height="12"
                  fill={getColor(
                    data[ticker]?.[
                      tabValue === 0
                        ? "current_trr_1d"
                        : tabValue === 1
                        ? "current_trr_5d"
                        : tabValue === 2
                        ? "current_trr_1mo"
                        : tabValue === 3
                        ? "current_trr_3mo"
                        : tabValue === 4
                        ? "current_trr_ytd"
                        : ""
                    ],
                  )}
                ></rect>
                <text
                  textAnchor="middle"
                  alignmentBaseline="central"
                  x={ticker2coordinates[ticker].markerX + 40}
                  y={ticker2coordinates[ticker].markerY + 18}
                  fontFamily="Verdana"
                  fontSize={8}
                  fill="white"
                >
                  {`${formatMarker(
                    data[ticker]?.[
                      tabValue === 0
                        ? "px_close_1d"
                        : tabValue === 1
                        ? "px_close_5d"
                        : tabValue === 2
                        ? "px_close_1m"
                        : tabValue === 3
                        ? "px_close_3m"
                        : tabValue === 4
                        ? "px_close_ytd"
                        : ""
                    ],
                    "absolute",
                  )} (${formatMarker(
                    data[ticker]?.[
                      tabValue === 0
                        ? "current_trr_1d"
                        : tabValue === 1
                        ? "current_trr_5d"
                        : tabValue === 2
                        ? "current_trr_1mo"
                        : tabValue === 3
                        ? "current_trr_3mo"
                        : tabValue === 4
                        ? "current_trr_ytd"
                        : ""
                    ],
                    "percent",
                  )})`}
                </text>
              </g>
            </Marker>
          ) : null;
        })}
      </ComposableMap>
      <Tooltip />
    </div>
  );
}

const formatMarker = (value, toggleValue) => {
  let roundedVal = Math.round((value + Number.EPSILON) * 100) / 100;
  //save space by round to whole numbers when either absolute and/or percent gets too big
  if (
    (Math.abs(roundedVal) >= 100 && toggleValue === "percent") ||
    (Math.abs(roundedVal) >= 1000 && toggleValue === "absolute")
  )
    roundedVal = parseInt(roundedVal).toLocaleString("en-US");
  else {
    roundedVal = roundedVal.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  let sign = "";
  if (value < 0) {
    sign = "-";
    roundedVal = roundedVal.substring(1);
  } else if (value > 0) sign = "+";

  if (toggleValue === "percent") {
    return `${sign}${roundedVal}%`;
  } else if (toggleValue === "absolute") {
    return `$${roundedVal}`;
  } else {
    return `${roundedVal}`;
  }
};

const getColor = (num) => {
  if (num > 0) return "#75ce41";
  else if (num < 0) return "#d33541";
  else return "#a6a6a6";
};
